import React from "react";

export function Logo({ size = 40, showText = false, className = "" }) {
  const url =
    "https://customer-assets-agu9un31.emergentagent.net/job_144208b3-9494-40cc-b4de-d3df27f3f1f4/artifacts/yz1bso4a_image.png";
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={url}
        alt="Lucas & Sons"
        style={{ width: size, height: size }}
        className="rounded-lg object-contain bg-white shadow-sm ring-1 ring-black/5"
      />
      {showText && (
        <div className="leading-tight">
          <div className="font-head font-bold text-[15px] text-primary tracking-tight">Lucas &amp; Sons</div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Butane Gas Service</div>
        </div>
      )}
    </div>
  );
}
